/*
 * Toff London customisation tester fixes v35
 * Staging theme only - 9 September 2026
 */
(function () {
  "use strict";

  var repeatDelay = 360;
  var repeatRate = 95;

  function setPreviewScale(dialog) {
    if (!dialog) return;
    var mobile = window.matchMedia("(max-width: 916px)").matches;
    if (!mobile) return;

    var compactHeight = Math.max(250, window.innerHeight * 0.5 - 48);
    var compactScale = Math.max(0.62, Math.min(1, (window.innerWidth - 20) / 412, compactHeight / 412));
    var fullScale = Math.max(0.7, Math.min(1.35, (window.innerWidth - 20) / 412, (window.innerHeight - 116) / 412));
    dialog.style.setProperty("--toff-preview-scale", String(compactScale));
    dialog.style.setProperty("--toff-full-preview-scale", String(fullScale));
  }

  function installFullscreenPreview(dialog) {
    if (!dialog || dialog.dataset.toffFullscreenReady === "true") return;
    var preview = dialog.querySelector(".w2shopify_dynamic_personalise_previewsets");
    var inner = preview && preview.querySelector(".w2shopify_dynamic_personalise_previewsets_inner");
    if (!preview || !inner) return;

    dialog.dataset.toffFullscreenReady = "true";
    var button = document.createElement("button");
    button.type = "button";
    button.className = "toff-preview-fullscreen-toggle";
    button.textContent = "Full screen";
    button.setAttribute("aria-expanded", "false");
    button.setAttribute("aria-label", "Open full screen preview");
    inner.appendChild(button);

    function closeFullscreen() {
      dialog.classList.remove("toff-preview-fullscreen");
      document.body.classList.remove("toff-preview-fullscreen-open");
      button.textContent = "Full screen";
      button.setAttribute("aria-expanded", "false");
      button.setAttribute("aria-label", "Open full screen preview");
    }

    button.addEventListener("click", function () {
      var opening = !dialog.classList.contains("toff-preview-fullscreen");
      dialog.classList.toggle("toff-preview-fullscreen", opening);
      document.body.classList.toggle("toff-preview-fullscreen-open", opening);
      button.textContent = opening ? "Close preview" : "Full screen";
      button.setAttribute("aria-expanded", opening ? "true" : "false");
      button.setAttribute("aria-label", opening ? "Close full screen preview" : "Open full screen preview");
      setPreviewScale(dialog);
    });

    dialog.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && dialog.classList.contains("toff-preview-fullscreen")) {
        event.stopPropagation();
        closeFullscreen();
        button.focus();
      }
    });

    setPreviewScale(dialog);
  }

  function variableForRange(range) {
    if (range.classList.contains("w2shopify_dynamic_personalise_possibility_inputs_input_offset_x")) return "offset_x";
    if (range.classList.contains("w2shopify_dynamic_personalise_possibility_inputs_input_offset_y")) return "offset_y";
    if (range.classList.contains("w2shopify_dynamic_personalise_possibility_inputs_input_scale")) return "scale";
    if (range.classList.contains("w2shopify_dynamic_personalise_possibility_inputs_input_rotation")) return "rotation";
    return null;
  }

  function installPrecisionButton(button) {
    if (!button || button.dataset.toffPressReady === "true") return;
    var row = button.parentNode;
    var range = row && row.querySelector("input");
    var possibility = button.closest("[data-possibilitypieceid]");
    var variable = range && variableForRange(range);
    var possibilityId = possibility && possibility.dataset.possibilitypieceid;
    if (!range || !variable || !possibilityId) return;

    button.dataset.toffPressReady = "true";
    button.removeAttribute("href");
    button.removeAttribute("onclick");
    button.setAttribute("role", "button");
    button.setAttribute("tabindex", "0");

    var isDown = button.classList.contains("w2shopify_dynamic_personalise_possibility_inputs_adjust_down");
    var amount = variable === "scale" ? (isDown ? -0.05 : 0.05) : (isDown ? -5 : 5);
    var delayTimer = null;
    var repeatTimer = null;
    var pressed = false;

    function applyAdjustment() {
      if (typeof window.w2shopify_dynamic_personalise_pi2_adjust === "function") {
        window.w2shopify_dynamic_personalise_pi2_adjust(possibilityId, variable, amount);
        range.dispatchEvent(new Event("input", { bubbles: true }));
      }
    }

    function stop() {
      pressed = false;
      window.clearTimeout(delayTimer);
      window.clearInterval(repeatTimer);
      delayTimer = null;
      repeatTimer = null;
      button.removeAttribute("data-pressed");
    }

    button.addEventListener("pointerdown", function (event) {
      if (event.button !== undefined && event.button !== 0) return;
      event.preventDefault();
      stop();
      pressed = true;
      button.setAttribute("data-pressed", "true");
      if (button.setPointerCapture && event.pointerId !== undefined) {
        try { button.setPointerCapture(event.pointerId); } catch (ignore) {}
      }
      applyAdjustment();
      delayTimer = window.setTimeout(function () {
        if (pressed) repeatTimer = window.setInterval(applyAdjustment, repeatRate);
      }, repeatDelay);
    }, { passive: false });

    button.addEventListener("pointerup", stop);
    button.addEventListener("pointercancel", stop);
    button.addEventListener("lostpointercapture", stop);
    button.addEventListener("contextmenu", function (event) { event.preventDefault(); });
    button.addEventListener("click", function (event) { event.preventDefault(); });
    button.addEventListener("keydown", function (event) {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        applyAdjustment();
      }
    });
  }

  function normaliseEngravingValue(value) {
    return String(value || "")
      .replace(/[\u2018\u2019\u201A\u201B]/g, "'")
      .replace(/[\u201C\u201D\u201E\u201F]/g, '"')
      .replace(/[\u2010\u2011\u2012\u2013\u2014\u2212]/g, "-")
      .replace(/\u00A0/g, " ")
      .replace(/[^A-Za-z0-9 &.,!?'()\/-]/g, "");
  }

  function installEngravingInput(input) {
    if (!input || input.dataset.toffEngravingFilterReady === "true") return;
    input.dataset.toffEngravingFilterReady = "true";
    input.setAttribute("inputmode", "text");
    input.setAttribute("autocomplete", "off");
    input.setAttribute("autocapitalize", "sentences");
    input.setAttribute("spellcheck", "false");
    input.setAttribute("aria-description", "Letters, numbers, spaces and common engraving punctuation only.");

    input.addEventListener("input", function () {
      var original = input.value;
      var cleaned = normaliseEngravingValue(original);
      var maximum = parseInt(input.dataset.maxlength || input.getAttribute("maxlength") || "0", 10);
      if (maximum > 0) cleaned = cleaned.slice(0, maximum);
      if (cleaned !== original) {
        var cursor = input.selectionStart;
        input.value = cleaned;
        if (typeof cursor === "number" && input.setSelectionRange) {
          var nextCursor = Math.min(cleaned.length, cursor);
          try { input.setSelectionRange(nextCursor, nextCursor); } catch (ignore) {}
        }
      }
    }, true);

    var initial = normaliseEngravingValue(input.value);
    var maximum = parseInt(input.dataset.maxlength || input.getAttribute("maxlength") || "0", 10);
    if (maximum > 0) initial = initial.slice(0, maximum);
    if (input.value !== initial) input.value = initial;
  }

  function installEngravingFilters(dialog) {
    var inputs = dialog.querySelectorAll(".w2shopify_dynamic_personalise_possibility_type_provided_text_1 .w2shopify_dynamic_personalise_possibility_inputs_input_text");
    Array.prototype.forEach.call(inputs, installEngravingInput);
  }

  function installExactRotation(dialog) {
    var rotations = dialog.querySelectorAll(".w2shopify_dynamic_personalise_possibility_inputs_input_rotation");
    Array.prototype.forEach.call(rotations, function (input) {
      input.step = "1";
      input.setAttribute("step", "1");
      input.setAttribute("aria-description", "Enter an exact angle. The adjacent buttons move in five degree steps.");
    });
  }

  function revealCustomButtonWhenReady() {
    var target = document.querySelector("#w2shopify_page_product_content");
    var ready = target && target.querySelector(".w2shopify_page_product_button");
    if (ready) document.documentElement.classList.remove("w2shopify-product-pending");
  }

  function install() {
    var dialog = document.getElementById("w2shopify_page_product_dialog");
    if (dialog) {
      installFullscreenPreview(dialog);
      installExactRotation(dialog);
      installEngravingFilters(dialog);
      setPreviewScale(dialog);
      var buttons = dialog.querySelectorAll(".w2shopify_dynamic_personalise_possibility_inputs_adjust");
      Array.prototype.forEach.call(buttons, installPrecisionButton);
    }
    revealCustomButtonWhenReady();
  }

  var observer = new MutationObserver(install);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener("resize", function () {
    setPreviewScale(document.getElementById("w2shopify_page_product_dialog"));
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", install);
  } else {
    install();
  }
})();
